
// // Get all the product tab title elements
// const tabTitles = document.querySelectorAll('.product_tab-title > h2');

// // Add click event listeners to each tab title
// tabTitles.forEach((title, index) => {
//   title.addEventListener('click', () => {
//     // Add active class to current tab title
//     title.classList.add('active');
//     // Remove active class from all other tab titles
//     tabTitles.forEach((t, i) => {
//       if (i !== index) {
//         t.classList.remove('active');
//       }
//     });

//     // Add active class to current product tab product
//     const productTabs = document.querySelectorAll('.product_tab-products > .product_tab-product');
//     productTabs.forEach((tab, i) => {
//       if (i === index) {
//         tab.classList.add('active');
//       } else {
//         tab.classList.remove('active');
//       }
//     });

//     // Add active class to current product tab image
//     const productImages = document.querySelectorAll('.product_tab-right > .product_tab-image');
//     productImages.forEach((img, i) => {
//       if (i === index) {
//         img.classList.add('active');
//       } else {
//         img.classList.remove('active');
//       }
//     });
//   });
// });

// const productImages = document.querySelectorAll('.product_tab-right .product_tab-img');

// // Add click event listeners to each product tab image
// // Add click event listeners to each product tab image
// productImages.forEach((image, i) => {
//   image.addEventListener('click', () => {
//     console.log(i);
//     // Add active class to the corresponding product tab item
//     const correspondingItem = document.querySelectorAll(`.product_tab-products .product_tab-product.active .product_tab-item:nth-child(${i + 1})`)[0];
//     correspondingItem.classList.add('active');

//     // Remove active class from all other product tab items
//     const productItems = document.querySelectorAll('.product_tab-products .product_tab-product.active .product_tab-item');
//     productItems.forEach((item) => {
//       if (item !== correspondingItem) {
//         item.classList.remove('active');
//       }
//     });
//   });
// });


const tabTitles = document.querySelectorAll('.product_tab-title > h2');

// Add click event listeners to each tab title
tabTitles.forEach((title, index) => {
  title.addEventListener('click', () => {
    // Add active class to current tab title
    title.classList.add('active');
    // Remove active class from all other tab titles
    tabTitles.forEach((t, i) => {
      if (i !== index) {
        t.classList.remove('active');
      }
    });

    // Add active class to current product tab product
    const productTabs = document.querySelectorAll('.product_tab-products > .product_tab-product');
    productTabs.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });

    // Add active class to current product tab image
    const productImages = document.querySelectorAll('.product_tab-right > .product_tab-image');
    productImages.forEach((img, i) => {
      if (i === index) {
        img.classList.add('active');
      } else {
        img.classList.remove('active');
      }
    });
  });
});

const productImages = document.querySelectorAll('.product_tab-right .product_tab-img');

// Add click event listeners to each product tab image
productImages.forEach((image, index) => {
  image.addEventListener('click', () => {
    // Calculate the index based on the parent element
    const parent = image.parentElement;
    const indexInParent = Array.from(parent.children).indexOf(image) + 1;

    // Add active class to the corresponding product tab item
    const correspondingItem = document.querySelector(`.product_tab-products .product_tab-product.active .product_tab-item:nth-child(${indexInParent})`);
    correspondingItem.classList.add('active');

    // Remove active class from all other product tab items
    const productItems = document.querySelectorAll('.product_tab-products .product_tab-product.active .product_tab-item');
    productItems.forEach((item) => {
      if (item !== correspondingItem) {
        item.classList.remove('active');
      }
    });
  });
}); 



  var flkty = new Flickity('.product-slider-container', {
prevNextButtons: false,
    wrapAround: true,
    autoPlay: true
  });






